import { render, staticRenderFns } from "./MilestoneCreateModal.vue?vue&type=template&id=6b63617e&scoped=true&"
import script from "./MilestoneCreateModal.vue?vue&type=script&lang=js&"
export * from "./MilestoneCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneCreateModal.vue?vue&type=style&index=0&id=6b63617e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63617e",
  null
  
)

export default component.exports